import React from 'react'
import PropTypes from 'prop-types'

export function Refresh({ size = '100%', colour = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 -2 16 16"
      fill="none"
    >
      <path
        d="M12.6667 5.33334L10 8H12C12 10.2067 10.2067 12 8.00002 12C7.32669 12 6.68669 11.8333 6.13335 11.5333L5.16002 12.5067C5.98002 13.0267 6.95335 13.3333 8.00002 13.3333C10.9467 13.3333 13.3334 10.9467 13.3334 8H15.3334L12.6667 5.33334ZM4.00002 8C4.00002 5.79334 5.79335 4.00001 8.00002 4.00001C8.67335 4.00001 9.31335 4.16667 9.86669 4.46667L10.84 3.49334C10.02 2.97334 9.04669 2.66667 8.00002 2.66667C5.05335 2.66667 2.66669 5.05334 2.66669 8H0.666687L3.33335 10.6667L6.00002 8H4.00002Z"
        fill={colour}
      />
    </svg>
  )
}

Refresh.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.any
}
